import { useEffect, useRef } from 'react';

export default function Hero() {
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (cardsRef.current) {
      const cards = cardsRef.current.querySelectorAll('.product-card');
      cards.forEach((card) => observer.observe(card));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #0A1628 0%, #1E293B 100%)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-7xl font-extrabold text-white mb-6" style={{ letterSpacing: '0.02em' }}>
          VALIDE d.o.o.
        </h1>
        
        <h2 className="text-6xl font-bold text-white mb-8 leading-tight">
          Crafting Premium <span className="text-teal-400">iOS</span> Experiences 📱
        </h2>
        
        <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed font-light">
          Expert team developing modern applications for enhanced security and user experience on the iOS platform.
        </p>

        <div ref={cardsRef} className="mt-20 flex items-center justify-center gap-8">
          <div className="product-card opacity-0 transform transition-all duration-700 hover:-translate-y-3">
            <div
              className="w-64 h-80 rounded-3xl shadow-2xl"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                transform: 'perspective(1000px) rotateY(-8deg)',
                boxShadow: '0 40px 80px rgba(0,0,0,0.4)',
              }}
            >
              <div className="p-8 h-full flex flex-col items-center justify-center text-white">
                <i className="ri-shield-check-line text-6xl mb-4"></i>
                <h3 className="text-2xl font-bold mb-2">VPN</h3>
                <p className="text-sm text-center opacity-90">Secure Connection</p>
              </div>
            </div>
          </div>

          <div className="product-card opacity-0 transform transition-all duration-700 hover:-translate-y-3" style={{ animationDelay: '0.2s' }}>
            <div
              className="w-64 h-80 rounded-3xl shadow-2xl"
              style={{
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                transform: 'perspective(1000px) rotateY(0deg)',
                boxShadow: '0 40px 80px rgba(0,0,0,0.4)',
              }}
            >
              <div className="p-8 h-full flex flex-col items-center justify-center text-white">
                <i className="ri-brush-line text-6xl mb-4"></i>
                <h3 className="text-2xl font-bold mb-2">Cleaner</h3>
                <p className="text-sm text-center opacity-90">Storage Optimization</p>
              </div>
            </div>
          </div>

          <div className="product-card opacity-0 transform transition-all duration-700 hover:-translate-y-3" style={{ animationDelay: '0.4s' }}>
            <div
              className="w-64 h-80 rounded-3xl shadow-2xl"
              style={{
                background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                transform: 'perspective(1000px) rotateY(8deg)',
                boxShadow: '0 40px 80px rgba(0,0,0,0.4)',
              }}
            >
              <div className="p-8 h-full flex flex-col items-center justify-center text-white">
                <i className="ri-smartphone-line text-6xl mb-4"></i>
                <h3 className="text-2xl font-bold mb-2">iOS Apps</h3>
                <p className="text-sm text-center opacity-90">Modern Design</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}